import _classCallCheck from "/codebuild/output/src953013697/src/young-platform-step/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/codebuild/output/src953013697/src/young-platform-step/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _inherits from "/codebuild/output/src953013697/src/young-platform-step/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _possibleConstructorReturn from "/codebuild/output/src953013697/src/young-platform-step/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/codebuild/output/src953013697/src/young-platform-step/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js";
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import React__default, { Component } from 'react';
import './loader.css.js';
var Loader = /*#__PURE__*/function (_Component) {
  _inherits(Loader, _Component);
  var _super = _createSuper(Loader);
  function Loader() {
    _classCallCheck(this, Loader);
    return _super.apply(this, arguments);
  }
  _createClass(Loader, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React__default.createElement("div", {
        style: this.props.style,
        className: "lds-ellipsis"
      }, /*#__PURE__*/React__default.createElement("div", null), /*#__PURE__*/React__default.createElement("div", null), /*#__PURE__*/React__default.createElement("div", null), /*#__PURE__*/React__default.createElement("div", null));
    }
  }]);
  return Loader;
}(Component);
export { Loader as default };